var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.5669C8.60015 11.5669 9.08666 11.0804 9.08666 10.4802C9.08666 9.88007 8.60015 9.39355 8 9.39355C7.39985 9.39355 6.91333 9.88007 6.91333 10.4802C6.91333 11.0804 7.39985 11.5669 8 11.5669Z",
    fill: "#444656"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1866 6.35301V5.51967C12.1866 3.71967 11.7533 1.33301 7.99998 1.33301C4.24665 1.33301 3.81331 3.71967 3.81331 5.51967V6.35301C1.94665 6.58634 1.33331 7.53301 1.33331 9.85967V11.0997C1.33331 13.833 2.16665 14.6663 4.89998 14.6663H11.1C13.8333 14.6663 14.6666 13.833 14.6666 11.0997V9.85967C14.6666 7.53301 14.0533 6.58634 12.1866 6.35301ZM7.99998 12.493C6.88665 12.493 5.98665 11.5863 5.98665 10.4797C5.98665 9.36634 6.89331 8.46634 7.99998 8.46634C9.10665 8.46634 10.0133 9.37301 10.0133 10.4797C10.0133 11.593 9.11331 12.493 7.99998 12.493ZM4.89998 6.29301C4.84665 6.29301 4.79998 6.29301 4.74665 6.29301V5.51967C4.74665 3.56634 5.29998 2.26634 7.99998 2.26634C10.7 2.26634 11.2533 3.56634 11.2533 5.51967V6.29967C11.2 6.29967 11.1533 6.29967 11.1 6.29967H4.89998V6.29301Z",
    fill: "#444656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.63e7f13c9da01d3bdc18a973f4c99b6c.svg";
export { ForwardRef as ReactComponent };